import React from "react";
import { Header } from "../../components/Header";
import { SolutionWechatBanner } from "../../blocks/solution-wechat-banner";
import { SolutionWechatContent } from "../../blocks/solution-wechat-content";
import "./styles.less";
import { SolutionConsult } from "../../blocks/common-solution-consult";
import { Footer } from "../../components/Footer";

export const WechatPage = () => {
  return (
    <div className="wechat-page">
      <Header mode="light" />
      <SolutionWechatBanner />
      <SolutionWechatContent />
      {/* <CommonLinkPage pagesLink={pagesLink} /> */}
      <SolutionConsult />
      <Footer />
    </div>
  );
};
